import React from 'react'

const CorporateProfile = () => {
  return (
    <div className="main-container">
      {/* Hero Section — same structure as Career hero */}
      <section className="Career-hero-section">
        <div className="Career-heading">
          <h2> Corporate Profile</h2>
        </div>
      </section>
      <h2 style={{textAlign:"center", paddingTop:"5%", color:"gray"}}>Details Coming Soon</h2>

    </div>
  )
}

export default CorporateProfile
